const fliggyMixins = {
  data() {
    return {
      currentDialogLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      proTypeList: [{ code: 4, name: '景酒' }],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'GoodsDelivery', title: '商品推送' },
      // { name: 'DirectOrders', title: '订单直连' },
      { name: 'AddReductionRecord', title: '加减价记录' },
      { name: 'AuthorizationCodeBinding', title: '授权码绑定' }
    ])
  }
}
export default fliggyMixins